import { Button } from '@planuze/ui';
import { useLegalContent } from '../../content/sections/legal.js';
import { BulkSelectionBar } from '../bulk-selection-bar.js';

interface Props {
  readonly selectedCount: number;
  readonly busy: boolean;
  readonly onRemove: () => void;
  readonly onClear: () => void;
}

export function LegalBulkBar({ selectedCount, busy, onRemove, onClear }: Props) {
  const copy = useLegalContent().bulk;
  if (selectedCount === 0) return null;
  return (
    <BulkSelectionBar
      selectedLabel={copy.selected(selectedCount)}
      clearLabel={copy.clear}
      busy={busy}
      onClear={onClear}
    >
      <Button size="sm" variant="destructive" disabled={busy} onClick={onRemove}>
        {copy.remove}
      </Button>
    </BulkSelectionBar>
  );
}
